import React from 'react';
import { Trash2 } from 'lucide-react';
import type { RateScenario } from '../../types';

interface Props {
  scenario: RateScenario;
  index: number;
  canDelete: boolean;
  onChange: (updated: RateScenario) => void;
  onDelete: () => void;
}

export function ScenarioCard({ scenario, index, canDelete, onChange, onDelete }: Props) {
  const update = (field: keyof RateScenario, value: string | number) => {
    onChange({ ...scenario, [field]: value });
  };

  return (
    <div className="border border-gray-200 rounded-lg p-4 space-y-3">
      <div className="flex items-center justify-between">
        <input
          type="text"
          value={scenario.name}
          onChange={(e) => update('name', e.target.value)}
          className="text-sm font-medium border-0 border-b border-transparent hover:border-gray-300 focus:border-indigo-500 focus:ring-0 p-0 bg-transparent"
          placeholder={`Scenario ${index + 1}`}
        />
        {canDelete && (
          <button onClick={onDelete} className="text-gray-400 hover:text-red-500">
            <Trash2 className="w-4 h-4" />
          </button>
        )}
      </div>

      <div className="grid grid-cols-2 gap-3 sm:gap-4">
        <div>
          <p className="text-xs font-medium text-gray-500 mb-2 uppercase tracking-wide">
            Payments (eTransfer RM)
          </p>
          <div className="space-y-2">
            <div>
              <label className="block text-xs text-gray-500">Fixed Fee ($)</label>
              <input
                type="number"
                step="0.01"
                min="0"
                value={scenario.paymentFixedFee}
                onChange={(e) => update('paymentFixedFee', e.target.value === '' ? 0 : parseFloat(e.target.value))}
                className="mt-0.5 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
              />
            </div>
            <div>
              <label className="block text-xs text-gray-500">Rate (%)</label>
              <input
                type="number"
                step="0.01"
                min="0"
                value={scenario.paymentRatePercent}
                onChange={(e) => update('paymentRatePercent', e.target.value === '' ? 0 : parseFloat(e.target.value))}
                className="mt-0.5 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
              />
            </div>
          </div>
        </div>

        <div>
          <p className="text-xs font-medium text-gray-500 mb-2 uppercase tracking-wide">
            Payouts (eTransfer SM)
          </p>
          <div className="space-y-2">
            <div>
              <label className="block text-xs text-gray-500">Fixed Fee ($)</label>
              <input
                type="number"
                step="0.01"
                min="0"
                value={scenario.payoutFixedFee}
                onChange={(e) => update('payoutFixedFee', e.target.value === '' ? 0 : parseFloat(e.target.value))}
                className="mt-0.5 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
              />
            </div>
            <div>
              <label className="block text-xs text-gray-500">Rate (%)</label>
              <input
                type="number"
                step="0.01"
                min="0"
                value={scenario.payoutRatePercent}
                onChange={(e) => update('payoutRatePercent', e.target.value === '' ? 0 : parseFloat(e.target.value))}
                className="mt-0.5 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
